<div class="more-actions">

    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="selectComment(comment)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
        </button>
        <button mat-menu-item (click)="removeComment(comment)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
        </button>
    </mat-menu>
</div>
